<template>
  <div class="content_box" >
    <div v-if="!feeCons.consId">
      <van-field v-model="consNo" center clearable placeholder="请输入要绑定的用电户号" />
      <div style="padding: 0.5rem 0.24rem">
        <van-button @click="queryFeeCons" type="primary" block>下一步</van-button>
      </div>
    </div>

    <div v-if="feeCons.consId" >
      <van-field disabled :value="feeCons.consNo" type="text" label="户号" />
      <van-field disabled :value="feeCons.consName" type="text" label="用户名" />
      <van-field disabled :value="feeCons.telNo" type="text" label="手机号"/>
      <van-field v-model="code" center clearable placeholder="请输入验证码">
        <template #button>
          <div v-if="show" class="querybtn" @click="sendCodeBeforeBindConsNo">获取验证码</div>
          <div v-else>{{times}}s</div>
        </template>
      </van-field>
      <div style="padding: 0.5rem 0.24rem 0 0.24rem;">
        <van-button @click="bindConsNo" type="primary" block>立即绑定</van-button>
        <div @click="backBefore" style="width:100%;color:#00a578;font-size: 14px;height: 0.65rem;line-height: 0.65rem;cursor: pointer;">返回上一步</div>
      </div>
    </div>
    
    <div class="note_box">
      <div class="note_title">温馨提示</div>
      <p>1、输入用户号点击获取，会发送验证码到用户关联的手机号，请查看短信。</p>
      <p>2、注册或变更手机号请持相关手续到管理处修改。</p>
      <p>3、要求输入的用户号为您在用电信息采集系统中的用户号</p>
    </div>
  </div>
</template>

<script>
import {
  queryFeeCons,
  sendCodeBeforeBindConsNo,
  bindConsNo
} from "@/api/user.js";
import Vue from "vue";
import { Cell, CellGroup, Button, Notify } from "vant";
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(Notify);
import { Field } from "vant";
Vue.use(Field);
export default {
  data() {
    return {
      code: "",
      times: 60,
      consNo: "",
      show: true,
      feeCons: {},
    };
  },
  methods: {
    backBefore() {
      this.feeCons = {};
    },
    queryFeeCons() {
      if (!this.consNo) {
        Notify({ type: "danger", message: "请先输入要绑定的户号！" });
        return;
      }
      var regex = /^\d+$/;
      if(!regex.test(this.consNo)) {
        Notify({ type: "danger", message: "请输入纯数字组成的户号" });
        return;
      }

      queryFeeCons(this.consNo).then(res => {
        if (res.data.status == 200) {
          this.feeCons = res.data.object;
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
      
    },

    getCode() {
      this.show = false;
      this.timer = setInterval(() => {
        this.times--;
        if (this.times === 0) {
          this.times = 60;
          this.show = true;
          clearInterval(this.timer);
        }
      }, 1000);
    },

    sendCodeBeforeBindConsNo() {
      if (!this.feeCons || !this.feeCons.consId) {
        Notify({ type: "danger", message: "请先查询要绑定的户号信息！" });
        return;
      }

      sendCodeBeforeBindConsNo(this.feeCons.consId).then(res => {
        if (res.data.status == 200) {
          Notify({ type: "success", message: "验证码发送成功！" });
          this.getCode();
        } else {
          Notify({ type: "danger", message: res.data.msg });
        }
      });
    },
    bindConsNo() {
      if (!this.feeCons || !this.feeCons.consId) {
        Notify({ type: "danger", message: "请先查询要绑定的户号信息！" });
        return;
      }

      if (this.consNo) {
        if (this.code) {
          bindConsNo({
            code: this.code,
            consId: this.feeCons.consId
          }).then(res => {
            if (res.data.status == 200) {
              Notify({ type: "success", message: "绑定成功" });
              this.$router.go(-1);
            } else {
              Notify({ type: "danger", message: res.data.msg });
            }
          });
        } else {
          Notify({ type: "danger", message: "请先获取验证码！" });
        }
      } else {
        Notify({ type: "danger", message: "请先获取户号！" });
      }
    }
  }
};
</script>
<style>
.van-button--block {
  height: 0.65rem;
  background-color: #00a578;
  border-color: #008c65;
}
.input_box {
  width: 90%;
  margin: 0 auto;
  margin-top: 20px;
  border: 1px solid #cccccc;
}
.querybtn {
  color: #0db197;
}
.note_title {
  top: -13px;
  left: 110px;
  width: 118px;
  font-size: 20px;
  color: #33bf93;
  font-weight: bold;
  position: absolute;
  background: #fff;
}

.note_box {
  padding: 20px;
  margin: 0 20px;
  margin-top: 50px;
  font-size: 14px;
  position: relative;
  border: 1px solid #33bf93;
}

p {
  text-align: left;
}
</style>